module.exports = __webpack_public_path__ + "img/CARDS.4613d904.svg";